

















import { Component, Vue } from 'vue-property-decorator';
import returnTheGoods from './address/returnTheGoods.vue';
import delivery from './address/delivery.vue';
import returnSearch from './address/returnSearch.vue';
@Component({ components: { returnTheGoods, delivery, returnSearch } })
export default class Name extends Vue {
  activeName: string = '2';
  searchForm: object = {};
  created() {}
  handleClick(tab, event) {
    console.log(tab, event);
  }
}
